/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * The user's preferred visit type
 */
export type DefaultVisitMetadataVisitTypePreference =
  (typeof DefaultVisitMetadataVisitTypePreference)[keyof typeof DefaultVisitMetadataVisitTypePreference];

export const DefaultVisitMetadataVisitTypePreference = {
  chat: "chat",
  audiovisual: "audiovisual",
} as const;
